module.exports = __webpack_public_path__ + "static/media/empty-todo.b265e20d.png";